module.exports = __webpack_public_path__ + "img/header_image.6946bf41.png";